<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Topbar',
  components: {},
  data () {
    return {
      contSelected: {},
      contadores: [],
      idSelected: 0
    }
  },
  created () {
    this.contadores = this.user.user.contadores
    this.loadIdSelected()
    this.contSelected = this.idSelected
    this.alteredContador()
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  methods: {
    ...mapActions('auth', ['ActionSignOut']),
    ...mapActions('menu', ['ToogleMenu']),
    signOut () {
      this.ActionSignOut()
      this.$router.push({ name: 'login' })
    },
    alteredContador () {
      localStorage.idContador = this.contSelected
      this.$emit('updateSelectedContador', this.contSelected)
    },
    loadIdSelected () {
      let newId = localStorage.idContador > 0 ? localStorage.idContador : this.contadores[0].id
      this.idSelected = newId
    }
  }
}
</script>

<template>
  <div>
    <div class="margin-top-bar"></div>
    <nav class="navbar navbar-expand navbar-secondary bg-blue-dt static-top fixed-top">
      <a class="navbar-brand mr-1 text-white" href="index.html">YzXML</a>
      <button class="btn btn-link btn-sm text-white order-0 order-sm-0" id="sidebarToggle" href="#">
        <i class="">
          <img class="img-download-button" src="@/assets/img/options.svg" v-on:click="ToogleMenu()">
        </i>
      </button>
      <div class="col">
        <div class="text-rigth">
          <select
            class="form-control text-white border-selected bg-blue-dt"
            v-model="contSelected"
            @change="alteredContador()"
          >
            <option v-for="subitem in contadores" :key="subitem.id" :value="subitem.value">
              {{subitem.description}}
            </option>
          </select>
        </div>
      </div>
      <ul class="navbar-nav ml-auto mr-0 mr-md-3 my-2 my-md-0">
        <li class="nav-item dropdown no-arrow mx-1">
          <a v-on:click="signOut" href="#" class="text-white">Sair</a>
        </li>
      </ul>
      <div class="margin-default-topbar"></div>
    </nav>
  </div>
</template>

<style scoped>
  .margin-top-bar{margin-top: 55px; box-shadow: 2px 1px 3px 2px #ddd}
  .img-download-button{width: 30px;}
  .border-selected{border: white;}
</style>
